// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"b43ae770","739":"56723f1d"}[chunkId] + ".chunk.js";
};